module.exports = __webpack_public_path__ + "da0e717829e033a69dec97f1e155ae42.woff2";